import { createSlice } from "@reduxjs/toolkit";
import { UpdateAppData } from "../types/UpdateAppType";
import { updateDueDiligenceDocAction } from "../action/updateDueDiligenceDocAction";

const initialState: UpdateAppData = {
  data: {},
  loading: false,
  error: null,
};

const updateDueDiligenceDocSlice = createSlice({
  name: "updateDueDiligenceDocSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateDueDiligenceDocAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateDueDiligenceDocAction.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(updateDueDiligenceDocAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const updateDueDiligenceDocReducer = updateDueDiligenceDocSlice.reducer;
